const COOKIE_KEYS = {
  USER_ID: "user_id",
  STAFF_ID: "staff_id",
  ENTERPRISE_ID: "enterprise_id",
  HOSPITAL_ID: "hospital_id",
  FACILITY_KIND: "facility_kind",
};

// Set cookie with 7 days expiry (matches typical JWT expiry)
const setCookie = (name, value, days = 7) => {
  const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/`;
};

const getCookie = (name) => {
  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  return match ? decodeURIComponent(match[2]) : null;
};

const deleteCookie = (name) => {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
};

const FACILITY_KIND_STORAGE_KEY = "facility_kind";

const normalizeFacilityKind = (value) => {
  const kind = String(value || "")
    .trim()
    .toLowerCase();
  if (kind === "yoga_studio" || kind === "hospital") return kind;
  return null;
};

const readFacilityKindFromToken = () => {
  try {
    const token = localStorage.getItem("user_token");
    if (!token) return null;
    const payloadPart = token.split(".")[1];
    if (!payloadPart) return null;
    const json = JSON.parse(
      atob(payloadPart.replace(/-/g, "+").replace(/_/g, "/")),
    );
    return normalizeFacilityKind(json?.facilityKind);
  } catch {
    return null;
  }
};

export const setUserCookies = (user) => {
  if (user?.userId) setCookie(COOKIE_KEYS.USER_ID, user.userId);
  if (user?.staffId) setCookie(COOKIE_KEYS.STAFF_ID, user.staffId);
  if (user?.enterpriseId) setCookie(COOKIE_KEYS.ENTERPRISE_ID, user.enterpriseId);
  if (user?.hospitalId) setCookie(COOKIE_KEYS.HOSPITAL_ID, user.hospitalId);
  const facilityKind =
    normalizeFacilityKind(user?.facilityKind) ||
    (user?.hospitalId ? "hospital" : null);
  if (facilityKind) {
    setCookie(COOKIE_KEYS.FACILITY_KIND, facilityKind);
    try {
      localStorage.setItem(FACILITY_KIND_STORAGE_KEY, facilityKind);
    } catch {
      /* ignore quota / private mode */
    }
  }
};

export const clearUserCookies = () => {
  Object.values(COOKIE_KEYS).forEach(deleteCookie);
  try {
    localStorage.removeItem(FACILITY_KIND_STORAGE_KEY);
  } catch {
    /* ignore */
  }
};

export const getUserCookie = (key) => {
  const cookieName = COOKIE_KEYS[key] || key;
  return getCookie(cookieName);
};

export const getFacilityKind = () => {
  const fromCookie = normalizeFacilityKind(getCookie(COOKIE_KEYS.FACILITY_KIND));
  if (fromCookie) return fromCookie;

  let fromStorage = null;
  try {
    fromStorage = normalizeFacilityKind(
      localStorage.getItem(FACILITY_KIND_STORAGE_KEY),
    );
  } catch {
    fromStorage = null;
  }
  if (fromStorage) return fromStorage;

  const fromToken = readFacilityKindFromToken();
  if (fromToken) return fromToken;

  // Legacy sessions without facilityKind: clinical default.
  return "hospital";
};

export { COOKIE_KEYS, getCookie };
